export enum ThemeSchemaStatus {
  Published = 'Published',
  Draft = 'Draft'
}
